exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container-table[data-v-84cab1d4] {\n\t\tmargin-bottom: 20px;\n}\n.tables th[data-v-84cab1d4] {\n        border: none;\n}\n.button-page[data-v-84cab1d4] {\n        float:right;\n        margin-right: 0.5em;\n}\n.no-border[data-v-84cab1d4] {\n        border: hidden;\n        background: none;\n}\nth[data-v-84cab1d4] {\n        padding: 1em;\n}\ntd[data-v-84cab1d4] {\n        padding:1em;\n}\n", ""]);

// exports
